module.exports = __webpack_public_path__ + "static/media/s-home_formats_webinar.b5ce58a6.jpg";